import React, { useEffect, useState } from 'react'
import './header.scss'
import siteUrl from '../../../utils/siteUrl'
import logo from '../../../assets/images/logo_black.svg'
import { useStaticQuery, graphql } from "gatsby"
import closeIcon from '../../../assets/images/icons/mask.svg'
import closeSearch from '../../../assets/images/icons/search.svg'
import moneyExchange from '../../../assets/images/icons/cambio-moneda.svg'
import europa from '../../../assets/images/icons/bandera-europa.svg'
import usa from '../../../assets/images/icons/bandera-usa.svg'
import InputSearch from '../../atoms/input-search/input-search'
import Redirect from '../../atoms/redirect/redirect'
import rightIcon from '../../../assets/images/icons/right.svg'
import { capitalize, utilGtm } from '../../../utils/utilGtm'
import OptionsRedirect from '../../molecules/options-redirect/options-redirect'
import useMobile from '../../../hooks/useMobile';


const Header = props => {   
    const [showingPrehomeAccess, setshowingPrehomeAccess] = useState(false);
    const { segmentActive, mobileMenuActive, /*setshowingPrehomeAccess,*/ setmobileMenuActive, /*showingPrehomeAccess,*/ showPrehome } = props
    let showPrehomeAccess = showingPrehomeAccess;
    const isMobile = useMobile();
    
    const { allContentfulMenu, contentfulHome, allContentfulAccesosSecundarios, contentfulInformacionGeneral } = useStaticQuery(graphql`
        query {
            allContentfulMenu(filter: {slug: {eq: "menu-de-navegacion"}}) {
                nodes {
                    nombre
                    slug
                    itemMenu {
                        titulo
                        slug
                        itemsMenu {
                            titulo
                            slug
                        }
                    }
                }
            }
            contentfulHome {
                segmentos {
                    nombre
                    slug
                    categorias {
                        slug
                        nombre
                    }
                }
            }
            allContentfulAccesosSecundarios {
                nodes {
                    nombre
                    slug
                    icono {
                        file {
                            url
                        }
                        description
                    }
                }
            }
            contentfulInformacionGeneral {
                compraDolar
                compraEuro
                ventaDolar
                ventaEuro
                urlDeIngresoABamnet
                textoDeIngresoABamnet
            }
        }
        `)
    const navigationList = allContentfulMenu.nodes[0].itemMenu
    const allSegments = contentfulHome.segmentos;

    const itemCategory = 'productos';

    const getCurrentPath = () => {
        var slugs = (typeof window !== undefined) ? window.location.pathname.split('/') : '';
        return (slugs.length > 1) ? slugs[1] : '';
    }

    const getMenuCategories = (active) => {
        const seg = allSegments.filter((seg, i) => seg.slug === active);
        return (seg.length > 0) ? seg[0].categorias : allSegments[0].categorias;
    }

    const mySegmentActive = segmentActive ? segmentActive : allSegments[0].slug;

    const [currentPath, setcurrentPath] = useState('')
    const [activeCollapse, setactiveCollapse] = useState(-1)
    const [isSeguros, setisSeguros] = useState(false)

    const menuCategories = getMenuCategories(mySegmentActive);

    useEffect(() => {              
        setcurrentPath(getCurrentPath());
        validateIsSeguros()
    }, [])

    const validateIsSeguros = () => {
        setisSeguros(window.location.pathname.split('/')[1] === 'seguros-agromercantil')
    }

    const handleClickMenuItem = (index, subItems, slug) => {
        if (index === activeCollapse) {
            setactiveCollapse(-1)
        } else if (slug === itemCategory) {
            setactiveCollapse(activeCollapse === itemCategory ? -1 : itemCategory)
        } else if (subItems) {
            setactiveCollapse(index)
        } else if (slug) {
            window.location.href = siteUrl + '/' + slug + '/'
        } else {
            window.location.href = siteUrl + '/'
        }
    }

    const sectionOthers = allContentfulAccesosSecundarios.nodes

    const handleSearcherClick = e => {
        e.preventDefault()
        setactiveCollapse('searcher')
    }

    const handleMoneyExchangeClick = e => {
        e.preventDefault()
        setactiveCollapse('money-exchange')
    }

    
    const handleClose = () => {        
        let container = document.getElementById('container-options');
        container.style.top = "68px";
        setshowingPrehomeAccess(false)
    }
    
    const sectionExchange = contentfulInformacionGeneral;

    
    
    const dateAccess = '2022/08/28'    
    const dateInitial = '2022/08/03'

    const handleShowPrehomeAccess = () => {
        //let isHome = window.location.pathname === '/';
        let today = new Date();
        let finalDay = new Date(dateAccess);
        let initial = new Date(dateInitial);

        /*if (today < finalDay && today >= initial && isHome) {
            setshowingPrehomeAccess(true);
        }*/
        if (today < finalDay && today >= initial ) {
            return true;
        }else{
            return false;
        }
    }
    
    return (
        
        <header className="o-header">
            
            {
                
                isMobile && handleShowPrehomeAccess() && !mobileMenuActive &&
                <div id="prehome-access" className="o-header-prehome-access">                    
                    <div className="o-header-prehome-access-container">
                        <img
                            className="o-header-prehome-access-close"
                            src={closeIcon}
                            alt="Ícono de borrado"
                            onClick={handleClose}
                        />
                        <div className="o-header-prehome-access-text">
                            En Bam evolucionamos para estar más cerca de ti.
                        </div>
                        <div id="access-button" className="o-header-prehome-access-button" onClick={() => showPrehome()}>
                            <img
                                alt='Ícono botón'
                                src={rightIcon}
                            />
                        </div>
                    </div>
                </div>
            }
            <div className="o-header-top">
                <div className="o-header-top-wrapper">
                    <div className="o-header-top-left">
                        {allSegments.map((item, index) => {
                            return (
                                <Redirect
                                    className={"o-header-top-left-item " + (mySegmentActive === item.slug ? 'active' : '')}
                                    gtm={utilGtm('gtmHomeClicHeader', item.slug)}
                                    key={index}
                                    url={`${item.slug}/`}>
                                    {item.nombre}
                                </Redirect>
                            )
                        })}
                    </div>
                    <div className="o-header-top-right">
                        {sectionOthers.map((item, index) => {
                            return (
                                <a
                                    className={
                                        "o-header-icon-label" +
                                        utilGtm('gtmHomeClicSolucionesFinancieras', item.slug)
                                    }
                                    href={siteUrl + '/' + item.slug + '/'}
                                    key={index}
                                    onClick={e => {
                                        (item.slug === 'buscar' || item.slug === 'buscador') && handleSearcherClick(e)
                                    }}
                                >
                                    <div className="o-header-label">{item.nombre}</div>
                                    <div className="o-header-icon">
                                        <img
                                            className="o-header-icon-img"
                                            alt="Ícono redirección"
                                            src={item.icono.file.url}
                                        />
                                    </div>
                                </a>
                            )
                        })}
                    </div>
                </div>
            </div>
            <nav className="o-header-bottom">
                <div className="o-header-bottom-wrapper">
                    <a className="o-header-bottom-logo" href={siteUrl + "/"}>
                        <img
                            src={logo}
                            className="o-header-bottom-logo-image"
                            alt="Bam logo principal"
                        />
                    </a>
                    <div>
                        <ul className="o-header-bottom-nav">
                            {
                                navigationList &&
                                navigationList.map((item, index) => {
                                    return (
                                        <li
                                            className={
                                                "o-header-bottom-nav-item " +
                                                ((currentPath === item.slug) || (activeCollapse === index) || (activeCollapse === itemCategory && activeCollapse === item.slug) ? 'active' : '')
                                                + utilGtm('gtmHomeClicHeader', item.titulo)
                                            }
                                            key={index}
                                            onClick={() => handleClickMenuItem(index, item.itemsMenu, item.slug)}
                                        >
                                            {item.titulo} { (item.itemsMenu || item.slug === itemCategory) && <i className={"o-icon fal fa-chevron-down " + ((activeCollapse === index || (activeCollapse === itemCategory && activeCollapse === item.slug)) ? 'active' : '')} />}
                                        </li>
                                    )
                                })
                            }
                        </ul>
                    </div>
                    
                    <div className={`o-header-bottom-right ${ !showingPrehomeAccess ? "no-prehome" : ""}`}>
                        <div className='o-header-bottom-right-money-exchange'>
                            
                                <span className='o-header-bottom-right-money-exchange-item-type'>USD</span>
                                <span>Compra: Q. {sectionExchange.compraDolar}</span>
                                <span className='o-header-bottom-right-money-exchange-item-sale'>Venta: Q. {sectionExchange.ventaDolar}</span>
                            
                                <span className='o-header-bottom-right-money-exchange-item-type'>EUR</span>
                                <span>Compra: $. {sectionExchange.compraEuro}</span>
                                <span className='o-header-bottom-right-money-exchange-item-sale'>Venta: $. {sectionExchange.ventaEuro}</span>
                                                 
                        </div>
                        {/*<div
                            className={"o-header-bottom-right-item gtmHomeClicHeaderTipoCambio" + ((activeCollapse === "money-exchange") ? 'active' : '')}
                            key={"money-exchange"}
                            onClick={(e) => handleMoneyExchangeClick(e)}
                        >
                            {"Tipo de Cambio"} <img src={moneyExchange} alt="Tipo de Cambio" className={".o-header-bottom-right-item-icon " + (activeCollapse === "money-exchange" ? 'active' : '')} />
                        </div>*/}
                        {/*<Redirect className={"button gtmHomeClicHeaderIngresarBamnet"} url={contentfulInformacionGeneral.urlDeIngresoABamnet}>
                            {contentfulInformacionGeneral.textoDeIngresoABamnet}
                    </Redirect>*/}
                        <div id="container-options" className="o-header-bottom-right-container-options">
                            <OptionsRedirect />  
                        </div>                                                                     
                        <div className="o-header-bottom-mobile">
                            <div className="o-header-bottom-mobile-search">
                                <Redirect url="buscador" gtm="gtmHomeClicHeaderBuscador">
                                    <img src={closeSearch} alt="icono de busqueda" />
                                </Redirect>
                            </div>
                            <div className="o-header-bottom-mobile-menu gtmHomeClicCloseMenu" onClick={() => { setmobileMenuActive(!mobileMenuActive);}}>
                                {
                                    mobileMenuActive ?
                                        <img
                                            className="o-header-bottom-mobile-menu-close"
                                            src={closeIcon}
                                            alt="Ícono de cerrar"
                                        />
                                        : <i className="fal fa-bars"></i>
                                }
                            </div>
                        </div>
                    </div>
                </div>               
            </nav>                        
            <div className={"o-header-desktop-collapse-container " + (showingPrehomeAccess ? 'showing-prehome' : '')} style={{ visibility: activeCollapse !== -1 ? 'visible' : 'hidden' }}>
                <div className="o-header-desktop-collapse">
                    <div className="o-header-dekstop-collapse-close gtmPaginaClicBuscarX" onClick={() => setactiveCollapse(-1)}>
                        <img
                            className="o-header-close-collapse"
                            src={closeIcon}
                            alt="Ícono de cerrar"
                        />
                    </div>
                    {
                        navigationList &&
                        <div className="o-header-desktop-collapse-title">
                            {navigationList[activeCollapse] ? navigationList[activeCollapse].titulo : activeCollapse === itemCategory ? 'Productos y Servicios' : ''}
                        </div>

                    }
                    <div className="o-header-desktop-collapse-list-subitems">

                        {
                            activeCollapse === 'searcher' ?
                                <div className="o-header-desktop-collapse-searcher-container">
                                    <InputSearch gtm="Buscador"/>
                                </div>
                                :
                                activeCollapse === 'money-exchange' ?
                                    <div className="o-header-desktop-collapse-exchange-container">
                                        <div className="o-header-desktop-collapse-exchange-container_item">
                                            <div className="o-header-desktop-collapse-exchange-container-item_titulo">
                                                <img src={usa} alt="Bandera estados unidos" />
                                                <h2>Dólar Americano</h2>
                                            </div>
                                            <div className="o-header-desktop-collapse-exchange-container-item_precios">
                                                <p><b>Compra: </b> Q. {sectionExchange.compraDolar}</p>
                                                <p><b>Venta: </b> Q. {sectionExchange.ventaDolar}</p>
                                            </div>


                                        </div>
                                        <div className="o-header-desktop-collapse-exchange-container_item">
                                            <div className="o-header-desktop-collapse-exchange-container-item_titulo">
                                                <img src={europa} alt="Eruopa" />
                                                <h2>Euro</h2>
                                            </div>
                                            <div className="o-header-desktop-collapse-exchange-container-item_precios">
                                                <p><b>Compra: </b>$. {sectionExchange.compraEuro}</p>
                                                <p><b>Venta: </b>$. {sectionExchange.ventaEuro}</p>
                                            </div>
                                        </div>
                                    </div>
                                    : navigationList && navigationList[activeCollapse] ?
                                        navigationList[activeCollapse].itemsMenu.map((item, index) => {
                                            return (
                                                <a
                                                    className="o-header-desktop-collapse-subitem"
                                                    key={index}
                                                    href={siteUrl + '/' + item.slug + '/'}
                                                >
                                                    {item.titulo}
                                                </a>
                                            )
                                        }) :
                                        <>                                            
                                            {
                                                menuCategories.map((item, index) => {
                                                    return (
                                                        <a
                                                            className={`o-header-desktop-collapse-subitem gtm${capitalize(mySegmentActive)}ClicDropDownProductosServicios${capitalize( item.nombre )}`}
                                                            key={index}
                                                            href={siteUrl + '/' + mySegmentActive + '/' + item.slug + '/'}
                                                        >
                                                            {item.nombre}
                                                        </a>
                                                    )
                                                })
                                            }
                                            {
                                                navigationList.find(n => n.slug === itemCategory).itemsMenu &&
                                                navigationList.find(n => n.slug === itemCategory).itemsMenu.map((item, index) => {
                                                    if (item.slug === 'bienes-en-venta' && isSeguros || item.slug === 'leads' && isSeguros) return null
                                                    return (
                                                        <a
                                                            className={"o-header-desktop-collapse-subitem " + utilGtm('gtmHomeClicHeaderSubMenu', item.titulo)}
                                                            key={index}
                                                            href={siteUrl + '/' + item.slug + '/'}
                                                        >
                                                            {item.titulo}
                                                        </a>
                                                    )
                                                })
                                            }
                                        </>
                        }
                    </div>
                </div>
            </div>            
        </header>
    )
}

export default Header
